module.exports = __webpack_public_path__ + "img/base-map-outdoor.f86609c4.png";